import { type JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import CameraIcon from '~/icons/camera';
import { cva } from 'class-variance-authority';

const cssClasses = cva('flex items-center gap-4');

interface FigureWrapperProps {
  captionClass: string;
  captionAndCredit: string;
  captionIcon?: boolean;
}

export default component$<FigureWrapperProps>(
  ({ captionClass, captionAndCredit, captionIcon = false }): JSX.Element => {
    return (
      <figure>
        <Slot />
        <div class={cssClasses({ class: captionClass })}>
          {captionIcon && <CameraIcon cssClasses='fill-grey' />}
          <figcaption dangerouslySetInnerHTML={captionAndCredit} />
        </div>
      </figure>
    );
  }
);
